export class Conforme {
    id: number
    common_area: number
    csite_id: number
    floor: string
    is_valid: boolean
    letter: string
    portal: string
    register_date: string
    csite_name: string
}